import Vue from 'vue';
import { LoadingService } from '@/services/index';
import { EventBus } from '@/event-bus/index';
import { getContentArea } from '@/contentful/index';

export default Vue.extend({
  methods: {
    openAddDebitCardScreen(params) {
      LoadingService.watchPromises(getContentArea([
        'add-debit-card-success',
        'add-debit-card-error',
        'add-debit-card-error-validate-dependent',
        'add-debit-card-error-add-dependent',
      ])).then((data) => {
        const CONTENT_AREAS = data[0];
        let paramsObj: any = {};
        if (CONTENT_AREAS) {
          if (CONTENT_AREAS[0] && CONTENT_AREAS[0].fields) {
            paramsObj.successMessage = CONTENT_AREAS[0].fields.content;
          }
          if (CONTENT_AREAS[1] && CONTENT_AREAS[1].fields) {
            paramsObj.submitErrorMessage = CONTENT_AREAS[1].fields.content;
          }
          if (CONTENT_AREAS[2] && CONTENT_AREAS[2].fields) {
            paramsObj.validateDependentErrorMessage = CONTENT_AREAS[2].fields.content;
          }
          if (CONTENT_AREAS[3] && CONTENT_AREAS[3].fields) {
            paramsObj.addDependentErrorMessage = CONTENT_AREAS[3].fields.content;
          }
        }
        paramsObj = Object.assign(paramsObj, params);
        EventBus.$emit('openOverlayWrapper', 'AddDebitCard', paramsObj);
      }).catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
        });
      });
    },
  },
});
